var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10151",
    "data-name": "Group 10151",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78667",
    "data-name": "Path 78667",
    d: "M6,0a6,6,0,1,0,6,6A6.023,6.023,0,0,0,6,0Zm.7,8.813a.7.7,0,0,1-1.406,0V5.3A.7.7,0,0,1,6.7,5.3ZM6,3.891a.7.7,0,1,1,.7-.7A.7.7,0,0,1,6,3.891Z",
    fill: "#7898ae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.f4481e29a7ba73136ce11c5820ac931e.svg";
export { ForwardRef as ReactComponent };